export const validateEmail = email => {
  return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
    email
  );
};

export const validateCpf = cpf => {
  cpf = cpf.replace(/[.\-/]+/g, "");

  if (cpf.length !== 11) return false;

  let firstDigitSum = 0;
  for (let i = 0; i < 9; i++)
    firstDigitSum += parseInt(cpf.charAt(i)) * (10 - i);
  let firstDigitRemainder = 11 - (firstDigitSum % 11);
  if (firstDigitRemainder === 10 || firstDigitRemainder === 11)
    firstDigitRemainder = 0;
  if (firstDigitRemainder !== parseInt(cpf.charAt(9))) return false;

  let secondDigitSum = 0;
  for (let i = 0; i < 10; i++)
    secondDigitSum += parseInt(cpf.charAt(i)) * (11 - i);
  let secondDigitRemainder = 11 - (secondDigitSum % 11);
  if (secondDigitRemainder === 10 || secondDigitRemainder === 11)
    secondDigitRemainder = 0;
  if (secondDigitRemainder !== parseInt(cpf.charAt(10))) return false;

  return true;
};

export const validateCnpj = cnpj => {
  cnpj = cnpj.replace(/[.\-/]+/g, "");

  if (cnpj.length !== 14) return false;

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  let digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;

  size = size + 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1))) return false;

  return true;
};
